import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import suppliersData from '../data/suppliersData';
import { Autoplay } from 'swiper/modules';
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function SuppliersSection() {
    const { t } = useTranslation();
    useScrollAnimation();
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col items-center justify-center mx-auto w-fit">
                <div className="js-scroll fade-top w-[90px] h-[30px]">
                    <img className="w-[100%] h-[100%]" src={require("../../assets/icons/lineMainTitle.svg").default} alt="" />
                </div>
                <div className="js-scroll fade-btm text-[35px] font-bold uppercase text-[#017E89]">{t("Our Suppliers")}</div>
                <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
            </div>
            <div className="container py-[20px] flex flex-col gap-[20px]">
                <div className="js-scroll fade-top swiper-container mySwiper">
                    <Swiper
                        modules={[Autoplay]}
                        slidesPerView={3}
                        spaceBetween={10}
                        autoplay={{
                            delay: 1500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            300: {
                                slidesPerView: 1,
                            },
                            370: {
                                slidesPerView: 2,
                            },
                            520: {
                                slidesPerView: 3,
                            },
                            750: {
                                slidesPerView: 4,
                            },
                            850: {
                                slidesPerView: 5,
                            },
                            1000: {
                                slidesPerView: 6,
                            },
                            1250: {
                                slidesPerView: 6,
                            },
                        }}
                        loop={true}
                    >
                        {suppliersData.map((suppliers, index) => (
                            <SwiperSlide key={index}>
                                <div className="w-[175px] h-[175px] flex justify-center items-center p-4 bg-[rgba(100,170,178,0.2)] rounded-[8px] p-2.5">
                                    <img src={suppliers.image} alt={suppliers.name} className="w-full h-auto max-w-[200px] object-contain" />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <Link className="js-scroll fade-btm mx-auto bg-[#017E89] w-fit px-[30px] py-[7px] rounded-[4px] text-white font-bold capitalize" to={"/suppliers"}>{t("Show More")}</Link>
            </div>
        </section>
    );
}